module.exports = __webpack_public_path__ + "img/icon-admin-edit.45261d61.svg";